personal-info-state {
  flex-direction: column;
  display: flex;
  min-height: 0;
  height: 100%;
}
